import React, { Component } from "react";
import clipboardCopy from "lib/clipboardCopy";
import CommonModalView from "presentational/common/modals/CommonModalView";
import { withStore } from "store/storeHandler";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

/** 지금 사용되지 않는중. */
class OptBtnForOthersOutfitModalView extends Component {
  static propTypes = {
    optionModalOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  getNowUrl() {
    return window.location.href;
  }

  handleLinkCopyClick = () => {
    const { onClose, NoticeModalActions } = this.props;
    onClose();
    clipboardCopy(this.getNowUrl());
    NoticeModalActions.openModal({
      content: <TXT name="msg_copyLink" />
    });
  };

  render() {
    const { optionModalOpen, onClose } = this.props;

    return (
      <div>
        <CommonModalView
          open={optionModalOpen}
          onClose={onClose}
          buttonList={[
            {
              primary: <TXT name="btnList_copyLink" />,
              secondary: null,
              func: this.handleLinkCopyClick
            }
          ]}
          firstButtonText={<TXT name="btnModal_close" />}
          firstButtonFunc={onClose}
        />
      </div>
    );
  }
}

export default withStore({
  dispatchMap: ["noticeModal"]
})(OptBtnForOthersOutfitModalView);
